import axios from 'axios'
import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import bgImage from "../../src/assets/images/maxresdefault.jpg"
import useAuth from '../hooks/UseAuth'
import ReactLoading from 'react-loading'
const URL = "https://oaucvbuilder.onrender.com/cv/auth/signin"

const Login = () => {
    const [userDetails, setUserDetails] = useState({});
    const [errMessage, setErrMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();
    const { setAuth } = useAuth();

    const handleChange = (e) =>{
        setUserDetails({
            ...userDetails, [e.target.name] : e.target.value
        })
    }

    const submitHandler = async (e) =>{
        e.preventDefault();
        setIsLoading(true);
        try {
            const response = await axios.post(URL, userDetails,
            {
              headers: {'Content-Type': 'application/json'}
            });
            console.log(response);
            const token = response.data.detail.token;
            const firstTimer = response.data.detail.first_timer;
            
            setAuth({"token": token, "email":userDetails.email});
            if(response.status === 200){
              localStorage.setItem("auth", JSON.stringify({"token": token, "email":userDetails.email, "firstTimer": firstTimer}));
            }
            navigate('/guides-and-instructions');
        } catch (error) {
            setErrMessage(error?.response?.data?.detail);
            console.log(error)
        }
        setIsLoading(false);
    }

  return (
    <div className="flex flex-wrap w-full h-screen">
        <div className="flex flex-col justify-center h-full w-full md:w-1/2">
            <div className="flex flex-col justify-center px-8 pt-8 my-auto md:justify-start md:pt-14 md:px-24 lg:px-32">
                <p className="text-3xl text-center mb-2">
                    Welcome.
                </p>
                <p className="text-center text-notification-red">
                    {errMessage}
                </p>
                <form onSubmit={submitHandler} className="flex flex-col pt-3">
                    <div className="flex flex-col pt-2">
                        <div className="flex relative ">
                            <span className="rounded-l-md inline-flex  items-center px-3 border-t bg-white border-l border-b  border-gray-300 text-gray-500 shadow-sm text-sm">
                                <svg width="15" height="15" fill="currentColor" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1792 710v794q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-794q44 49 101 87 362 246 497 345 57 42 92.5 65.5t94.5 48 110 24.5h2q51 0 110-24.5t94.5-48 92.5-65.5q170-123 498-345 57-39 100-87zm0-294q0 79-49 151t-122 123q-376 261-468 325-10 7-42.5 30.5t-54 38-52 32.5-57.5 27-50 9h-2q-23 0-50-9t-57.5-27-52-32.5-54-38-42.5-30.5q-91-64-262-182.5t-205-142.5q-62-42-117-115.5t-55-136.5q0-78 41.5-130t118.5-52h1472q65 0 112.5 47t47.5 113z">
                                    </path>
                                </svg>
                            </span>
                            <input type="email" name='email' onChange={handleChange} id="login-email" className="rounded-r-md flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-1 focus:ring-purple-600 focus:border-transparent" placeholder="Email" required/>
                        </div>
                    </div>
                    <div className="flex flex-col pt-4 mb-8">
                        <div className="flex relative ">
                            <span className="rounded-l-md inline-flex  items-center px-3 border-t bg-white border-l border-b  border-gray-300 text-gray-500 shadow-sm text-sm">
                                <svg width="15" height="15" fill="currentColor" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1376 768q40 0 68 28t28 68v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h32v-320q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5q0 26-19 45t-45 19h-64q-26 0-45-19t-19-45q0-106-75-181t-181-75-181 75-75 181v320h736z">
                                    </path>
                                </svg>
                            </span>
                            <input type="password" name='password' onChange={handleChange} id="login-password" className="rounded-r-md flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-1 focus:ring-purple-600 focus:border-transparent" placeholder="Password" required/>
                        </div>
                    </div>
                    <button type="submit" className="w-full px-4 py-2.5 text-base font-semibold text-center text-white bg-custom-dark-blue shadow-md focus:outline-none focus:ring-1 rounded-md hover:text-slate-400 hover:bg-custom-button-hover"> 
                        <span className="w-full h-[25px] flex flex-row items-center justify-center">
                            {
                                isLoading ? <ReactLoading type="spin" className='text-base font-medium' width={20} height={20} color='#fff' /> 
                                : "Login"
                            }
                        </span>
                    </button>
                </form>
                <div className="pt-12 pb-12 text-center">
                    <p className='mb-1'>
                        Don&#x27;t have an account? &nbsp;
                        <Link to="/signup" className="font-semibold underline hover:text-custom-dark-blue">
                            Sign Up here.
                        </Link>
                    </p>
                    <p>
                        Haven't verified your account? &nbsp;
                        <Link to="/verify-account" className="font-semibold underline hover:text-custom-dark-blue">
                            Verify here.
                        </Link>
                    </p>
                </div>
            </div>
        </div>
        <div className="w-1/2 shadow-2xl">
            <img className="hidden object-cover object-right w-full h-screen md:block" alt='' src={bgImage}/>
        </div>
    </div>
  )
}

export default Login